// Lista los BookingProfiles de la org y muestra el link público.

import { useBookingProfiles } from '../hooks/useBookings';

export function ProfilesList() {
  const { data, isLoading, error } = useBookingProfiles();

  return (
    <div className="p-6 space-y-3">
      <h1 className="text-xl font-semibold">Perfiles de reserva</h1>
      <p className="text-sm text-muted-foreground">
        Cada perfil tiene su propia página pública en{' '}
        <code>/book/&lt;org_slug&gt;/&lt;slug&gt;/</code>. Los perfiles
        inactivos responden 404.
      </p>

      {isLoading && <div className="text-muted-foreground">Cargando…</div>}
      {error && (
        <div className="text-red-500">Error: {(error as Error).message}</div>
      )}
      {data && data.length === 0 && (
        <div className="text-muted-foreground">
          Aún no hay perfiles. Crea uno desde el API admin o el shell de Django.
        </div>
      )}
      {data && data.length > 0 && (
        <ul className="space-y-2">
          {data.map((p) => (
            <li
              key={p.id}
              className="border border-border rounded p-3 flex items-center justify-between"
            >
              <div>
                <div className="font-medium">{p.display_name}</div>
                <div className="text-xs text-muted-foreground">
                  /book/{p.org_slug}/{p.slug}/ · TZ {p.timezone} · buffer{' '}
                  {p.buffer_minutes}min
                </div>
              </div>
              <span
                className={`text-xs px-2 py-0.5 rounded ${
                  p.is_active
                    ? 'bg-emerald-900 text-emerald-100'
                    : 'bg-zinc-700 text-zinc-100'
                }`}
              >
                {p.is_active ? 'activo' : 'inactivo'}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
